import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { PUBLICATION_URL } from 'Common/consts';
import { ExternalLink } from 'Shared/components';
const PublicationLink = ({ children, className, }) => (_jsx(ExternalLink, Object.assign({ to: PUBLICATION_URL, className: className, title: "Rare variant contribution to human disease in 281,104 UK Biobank exomes", target: "_blank", isTextFieldLink: true }, { children: children || PUBLICATION_URL }), void 0));
export default memo(PublicationLink);
